import React from 'react';
import {
  CardText,
  CustomCard,
  CustomCardContent,
  InsightsCardTitle,
  PercentageBar,
  PercentageBarContainer,
  PercentageBarRow,
} from 'spw-esa-projects/building-details/occupancy-and-utilization/cards/styles';
import { asPercentageRounded, numberWithCommasOrDash } from 'spw-shared/utils';
import { RoundVM, SpacesSummary } from 'spw-redux/modules/ou/types';
import { TabValue } from 'spw-esa-projects/building-details/occupancy-and-utilization/types';
import { Box } from '@mui/material';
import {
  ColorDot,
  CategoryDotWrapper,
} from 'spw-esa-projects/building-details/occupancy-and-utilization/styles';
import { useCategoryColor } from 'spw-esa-projects/building-details/occupancy-and-utilization/cards/hooks';
import SelectedRoundsRow from 'spw-esa-projects/building-details/occupancy-and-utilization/cards/selected-rounds-row';

type Props = {
  category: TabValue;
  summary?: SpacesSummary;
  selectedRounds: Omit<RoundVM, 'buildings'>[];
};

const AverageOccupancy = ({ category, summary, selectedRounds }: Props) => {
  const color = useCategoryColor(category);

  return (
    <CustomCard elevation={0}>
      <CustomCardContent>
        <InsightsCardTitle>
          <CategoryDotWrapper>
            <ColorDot color={color} className="colorDot" />
          </CategoryDotWrapper>
          <Box display="flex">AVERAGE OCCUPANCY</Box>
        </InsightsCardTitle>
        <PercentageBarRow>
          <Box className="value">
            {summary?.averageOccupancy === undefined
              ? '--'
              : asPercentageRounded(summary?.averageOccupancy)}
          </Box>
          <Box
            display="flex"
            flex={1}
            justifyContent="center"
            alignItems="center"
          >
            <PercentageBarContainer>
              <PercentageBar
                width={`${
                  (Math.min(summary?.averageOccupancy, 1.0) || 0) * 100
                }%`}
                color={color}
              />
            </PercentageBarContainer>
          </Box>
        </PercentageBarRow>
        <SelectedRoundsRow selectedRounds={selectedRounds} />
        <CardText>
          <p>
            <b>{numberWithCommasOrDash(summary?.inUse)}</b> Observed Spaces In
            Use /
          </p>
          <p>
            <b>{numberWithCommasOrDash(summary?.observed)}</b> Observed Spaces
          </p>
        </CardText>
      </CustomCardContent>
    </CustomCard>
  );
};

export default AverageOccupancy;
